<template>
  <place-item></place-item>
</template>

<script>
import PlaceItem from '@/components/PlaceItem.vue';

export default{
  components: { PlaceItem}
}
</script>

<style scoped>

</style>